import { Button, Flex, Result } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useDocumentTitle } from 'src/hooks'

export const NotFound = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  useDocumentTitle(t('not_found.title'))

  // Mirrors ebs-platform-web: return where the user came from, and only fall
  // back to the root when this was a fresh tab with no history.
  const onGoBack = () => {
    if (window.history.length > 1) {
      window.history.back()
    } else {
      void navigate('/')
    }
  }

  return (
    <Flex justify="center" align="center" className="h-full">
      <Result
        status={404}
        title="404"
        subTitle={t('not_found.title')}
        extra={
          <Button type="primary" onClick={onGoBack}>
            {t('back')}
          </Button>
        }
      />
    </Flex>
  )
}
